import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';

const HomePage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box textAlign="center" mt={5}>
        <Typography variant="h3" gutterBottom>
          Welcome to US Citizen Interview Flashcards
        </Typography>
        <Typography variant="h6" gutterBottom>
          Press ready to start
        </Typography>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Button variant="contained" color="primary" size="large" href="/play">
          Ready
        </Button>
        <Button variant="contained" color="secondary" size="large" href="/setting" style={{ marginTop: '10px' }}>
          Setting
        </Button>
        </div>
      </Box>
    </Container>
  );
};

export default HomePage;